import { render, staticRenderFns } from "./ChangeLoginData.vue?vue&type=template&id=fdc2798a&scoped=true"
import script from "./ChangeLoginData.vue?vue&type=script&lang=js"
export * from "./ChangeLoginData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdc2798a",
  null
  
)

export default component.exports